import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  ChangeDetectorRef,
  SkipSelf,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  ControlContainer,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { MixinFunctionsService } from "src/app/pages/services/mixin-functions.service";
@Component({
  selector: "app-autocomplete",
  templateUrl: "./autocomplete.component.html",
  styleUrls: ["./autocomplete.component.scss"],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
})
export class AutocompleteComponent implements OnInit {
  formObject: any = {};
  changed: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public mixins: MixinFunctionsService,
    private changeDetector: ChangeDetectorRef,
    private controlContainer: ControlContainer
  ) {}

  control = new FormControl();
  @Input() public form: FormGroup;
  @Input() options: any[];
  @Input() displayName: string;
  @Input() returnType: string;
  @Input() label: string;
  @Input() validate: boolean = false;
  @Input() controlName: string;
  @Input() errorMessage: string;
  @Output() selectChanges: EventEmitter<any> = new EventEmitter();

  filteredOptions: Observable<any[]>;

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    //console.log("chnges", changes);

    if (changes) {
      this.initForm();
      this.initFilters();
      //this.isSelectedValid;
    }
    if (changes && changes.displayName && changes.displayName.currentValue) {
      this.displayName = changes.displayName.currentValue;
      //
    }
  }

  initForm() {
    this.form = <FormGroup>this.controlContainer.control;
    this.control = <FormControl>this.form.get(this.controlName);
    // this.formObject[`${this.controlName}`] =
    //   this.validate === true ? ["", Validators.required] : [null];

    // this.form = this.formBuilder.group({
    //   ...this.formObject,
    // });
  }

  initFilters() {
    this.filteredOptions = this.form.valueChanges.pipe(
      startWith(""),
      map((value) => {
        let filterKey = "";
        if (typeof value === "object" && value !== null) {
          if (
            value[this.controlName] &&
            value[this.controlName][this.controlName]
          ) {
            filterKey = value[this.controlName][this.controlName];
          } else if (value[this.controlName]) {
            filterKey = value[this.controlName];
          }
        }

        return typeof value === "string" ? value : filterKey;
      }),
      map((keyName) => {
        return keyName && keyName.length > 0
          ? this._filter(keyName)
          : this.options && this.options.slice();
      })
    );
  }

  displayFn = (selectedObject) => {
    return selectedObject && selectedObject[this.displayName]
      ? selectedObject[this.displayName]
      : "";
  };

  _filter = (filterKey: string) => {
    const filterValue = filterKey.toLowerCase();
    return this.options.filter((item) => {
      return Object.keys(item).some((key) => {
        return String(item[key])
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      });
    });
  };

  get isSelectedValid() {
    let selected = this.form.get(this.controlName).value;

    if (selected) {
      return this.options &&
        this.options.filter(
          (data) => data[this.displayName] === selected[this.displayName]
        ).length === 0
        ? this.form.get(this.controlName).setErrors({ INVALID_VALUE: true })
        : this.form.get(this.controlName).clearValidators();
    } else {
      return false;
    }
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  onChange(data) {
    this.selectChanges.emit(data);
  }
}
